/**
 * PDF Generation Utility for ALL IN LOGISTICS
 * Matches the official Allin Logistics centered-logo format exactly.
 */

const COMPANY = 'ALL IN LOGISTICS PTE LTD';
const ADDRESS = '10 Buroh Street, #08-06 West Connect Building, Singapore 627564';
const CONTACT_HP = 'Hp: (65) 8785 7340';
const CONTACT_TEL = 'Tel: (65) 6248 0993';
const EMAIL = 'ops@allinlog.com';
const WEBSITE = 'www.allinlog.com';

const baseStyles = `
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Inter', Arial, sans-serif; color:#334; padding:40px; font-size:11px; line-height:1.4; background:#fff; }
  
  .header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-bottom: 2px solid #1e3a8a; padding-bottom: 20px; }
  .logo-img { height:100px; width:auto; margin-bottom:12px; }
  .doc-title { font-size:28px; font-weight:900; color:#1e3a8a; text-transform:uppercase; letter-spacing:1px; }

  .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-bottom: 30px; }
  .meta-item { display: flex; margin-bottom: 8px; border-bottom: 1px dotted #ccc; padding-bottom: 4px; }
  .meta-label { width: 100px; font-weight: 800; color: #64748b; text-transform: uppercase; font-size: 9px; }
  .meta-value { flex: 1; font-weight: 700; color: #1e293b; }

  .consignment-header { background: #1e3a8a; color: #fff; padding: 10px 15px; font-size: 13px; font-weight: 800; text-transform: uppercase; margin-bottom: 20px; border-radius: 4px; -webkit-print-color-adjust: exact; }

  table { width:100%; border-collapse:collapse; margin-bottom:30px; }
  th { background:#f8fafc !important; color:#475569; padding:12px 10px; text-align:left; font-size:10px; font-weight:800; border-bottom:2px solid #1e3a8a; text-transform:uppercase; -webkit-print-color-adjust: exact; }
  td { padding:12px 10px; border-bottom:1px solid #f1f5f9; font-size:11px; color:#334; vertical-align: top; }
  tr:nth-child(even) { background: #fcfdfe; }
  
  .summary-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 20px; margin-bottom: 30px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .summary-item { display: flex; flex-direction: column; }
  .summary-label { font-size: 9px; font-weight: 800; color: #64748b; text-transform: uppercase; margin-bottom: 4px; }
  .summary-value { font-size: 16px; font-weight: 900; color: #1e3a8a; }

  .remarks-section { margin-bottom: 40px; padding: 15px 20px; border-left: 4px solid #1e3a8a; background: #f1f5f9; border-radius: 0 8px 8px 0; }
  .remarks-title { font-size: 10px; font-weight: 800; color: #1e3a8a; text-transform: uppercase; margin-bottom: 6px; }

  .signature-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; margin-top: 60px; }
  .sig-placeholder { border-bottom: 2px solid #1e293b; height: 70px; margin-bottom: 12px; }
  .sig-label { font-size: 10px; font-weight: 800; text-transform: uppercase; color: #64748b; }

  .footer-full { margin-top: 80px; padding-top: 24px; border-top: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: flex-end; }
  .footer-contact { font-size: 10px; color: #94a3b8; line-height: 1.6; }
  .footer-brand { font-size: 18px; font-weight: 900; color: #cbd5e1; }

  @media print { 
    body { padding:0; } 
    .no-print { display:none !important; } 
    th { background-color: #f8fafc !important; }
    .consignment-header { background-color: #1e3a8a !important; color: #fff !important; }
  }
`;

function openReportWindow(title, htmlContent) {
  const w = window.open('', '_blank', 'width=1000,height=900');
  w.document.write(`<!DOCTYPE html><html><head><title>${title}</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet">
    <style>${baseStyles}</style>
  </head><body>
    <div class="no-print" style="padding:15px 40px;background:#f8fafc;border-bottom:1px solid #e2e8f0;display:flex;gap:12px;justify-content:center;position:sticky;top:0;z-index:100;align-items:center;">
      <button onclick="window.print()" style="padding:10px 24px;background:#1e3a8a;color:#fff;border:none;border-radius:6px;font-weight:700;cursor:pointer;font-size:14px;box-shadow:0 4px 6px -1px rgba(30,58,138,0.2);">🖨 Print / Save as PDF</button>
      <button onclick="window.close()" style="padding:10px 24px;background:#fff;color:#64748b;border:1px solid #e2e8f0;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;">✕ Close Window</button>
    </div>
    <div style="max-width: 900px; margin: 0 auto; padding: 40px;">
      ${htmlContent}
    </div>
  </body></html>`);
  w.document.close();
}

/**
 * Main Delivery Note Generation
 */
export function generateDeliveryNotePDF(dn, items) {
  const dnItems = items || [];

  const rows = dnItems.map((item, i) => `
    <tr>
      <td style="font-weight:700; color:#1e3a8a; width:35px;">${String(i + 1).padStart(2, '0')}</td>
      <td style="width:115px; word-wrap:break-word;"><b>${item.vessel || dn.vessel || '—'}</b></td>
      <td style="width:135px; word-wrap:break-word;">${item.supplier || '—'}</td>
      <td style="width:70px; white-space:nowrap;">${item.frtType || 'General'}</td>
      <td style="width:90px; word-wrap:break-word;">${item.awb || '—'}</td>
      <td style="width:150px; font-weight:800; color:#1e293b; word-wrap:break-word;">${item.po}</td>
      <td style="text-align:center; width:65px; white-space:nowrap;"><span style="background:#e0f2fe; padding:4px 8px; border-radius:4px; font-weight:800; color:#0369a1; font-size:10px; -webkit-print-color-adjust: exact;">${item.qty} ${item.pkgType || 'PKG'}</span></td>
      <td style="text-align:right; font-weight:800; width:75px; color:#1e3a8a;">${item.weight} ${item.unit || 'KGS'}</td>
    </tr>`).join('');

  const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });

  const content = `
    <div class="header-flex">
      <div>
        <img src="/logo.png" class="logo-img" />
        <div style="font-size:12px; font-weight:900; color:#1e3a8a; letter-spacing:0.5px;">ALL IN LOGISTICS PTE LTD</div>
      </div>
      <div class="doc-title">${(String(dn.doc_type).toLowerCase().includes('release')) ? 'RELEASE NOTE' : 'DELIVERY NOTE'}</div>
    </div>
    
    <div class="meta-grid">
      <div>
        <div class="meta-item"><span class="meta-label">DN Number</span><span class="meta-value" style="font-family:monospace; font-size:15px; color:#1e3a8a; letter-spacing:0.5px;">${dn.dnNumber || dn.dn_number}</span></div>
        <div class="meta-item"><span class="meta-label">Delivery Date</span><span class="meta-value">${dn.deliveryDate || dn.delivery_date || today}</span></div>
        <div class="meta-item"><span class="meta-label">Company</span><span class="meta-value">${dn.customer || '—'}</span></div>
      </div>
      <div>
        <div class="meta-item"><span class="meta-label">Deliver To</span><span class="meta-value" style="font-weight:800;">${dn.deliveredTo || dn.delivered_to || '—'}</span></div>
        <div class="meta-item"><span class="meta-label">Destination</span><span class="meta-value">${dn.destination || '—'}</span></div>
      </div>
    </div>

    <div class="consignment-header">Air-Sea Freight Consignment Details</div>

    <table style="table-layout:fixed;">
      <thead>
        <tr>
          <th style="width:35px;">SN</th>
          <th style="width:115px;">Vessel Name</th>
          <th style="width:135px;">Supplier</th>
          <th style="width:70px;">Freight</th>
          <th style="width:90px;">AWB/BL/LR</th>
          <th style="width:150px;">PO Number</th>
          <th style="text-align:center; width:65px;">Qty</th>
          <th style="text-align:right; width:75px;">Weight</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>

    <div class="summary-box" style="grid-template-columns: 1fr 1fr; margin-bottom: 20px;">
      <div class="summary-item"><span class="summary-label">Total Packages</span><span class="summary-value">${dn.manual_packages || dn.packages || dnItems.reduce((acc, it) => acc + (+it.qty || 0), 0)} ${dn.package_type || dn.packageType || 'PKG'}</span></div>
      <div class="summary-item"><span class="summary-label">Gross Weight</span><span class="summary-value">${dn.manual_total_weight || dn.totalWeight || 0} KGS</span></div>
    </div>

    ${(dn.manual_dimensions || dn.dims) && (dn.manual_dimensions || dn.dims) !== '—' ? `
      <div style="margin-bottom: 30px; padding: 15px; border: 1px solid #e2e8f0; border-radius: 8px;">
        <div style="font-size: 9px; font-weight: 800; color: #64748b; text-transform: uppercase; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
          📏 Dimensions for ${(dn.manual_dimensions || dn.dims).split(',').length} Item(s)
        </div>
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
          ${(dn.manual_dimensions || dn.dims).split(',').map((d, i) => {
    const parts = d.trim().split(/X|x/);
    return `
              <div style="padding: 8px 10px; background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 6px; font-family: monospace; font-size: 10px;">
                <b style="color:#1e3a8a; margin-right:5px;">#${i + 1}</b>
                ${parts.length === 3 ? `${parts[0]}(L) x ${parts[1]}(W) x ${parts[2]}(H) cm` : d.trim()}
              </div>
            `;
  }).join('')}
        </div>
      </div>
    ` : ''}

    ${(dn.remarks || dn.fixedRemarks || dn.fixed_remarks) ? `
      <div class="remarks-section">
        <div class="remarks-title">Fulfillment Instructions / Remarks</div>
        <div style="font-size: 11px; color:#334; line-height:1.6;">${dn.remarks || dn.fixedRemarks || dn.fixed_remarks}</div>
      </div>
    ` : ''}

    <div style="font-size: 11px; font-weight: 800; color:#1e3a8a; margin-top:20px; text-align:center; opacity:0.8;">
      RECEIVED IN GOOD ORDER, QUANTITY AND CONDITION.
    </div>

    <div class="signature-grid">
      <div>
        <div class="sig-placeholder"></div>
        <div class="sig-label">Authorized Signature & Stamp</div>
      </div>
      <div>
        <div class="sig-placeholder"></div>
        <div class="sig-label">Receiver's Name / Date / Vessel Stamp</div>
      </div>
    </div>

    <div class="footer-full">
      <div class="footer-contact">
        <div style="font-weight:800; color:#64748b; margin-bottom:4px; text-transform:uppercase;">ALL IN LOGISTICS</div>
        <div>${ADDRESS}</div>
        <div>HP: ${CONTACT_HP} | TEL: ${CONTACT_TEL} | Email: ${EMAIL}</div>
      </div>
      <div class="footer-brand">
        <img src="/logo.png" style="height:45px; width:auto; opacity:0.8;" />
      </div>
    </div>
  `;

  openReportWindow(`DN-${dn.dnNumber}`, content);
}

// Fallback functions for other reports
export function generateStocklistPDF(items) {
  const rows = items.map((s, i) => `
    <tr>
      <td style="font-weight:700; color:#1e3a8a; width:30px;">${i + 1}</td>
      <td style="width:65px; white-space:nowrap;">${s.entry_date ? String(s.entry_date).split('T')[0] : (s.date || '—')}</td>
      <td style="width:130px; font-weight:800; word-wrap:break-word;">${s.po}</td>
      <td style="width:85px; word-wrap:break-word;">${s.vessel}</td>
      <td style="width:85px; word-wrap:break-word;">${s.awb || s.awb_bl_number || '—'}</td>
      <td style="width:85px; word-wrap:break-word;">${s.customer}</td>
      <td style="width:110px; word-wrap:break-word;">${s.supplier || '—'}</td>
      <td style="width:85px; word-wrap:break-word;">${s.dimension || s.dimensions || '—'}</td>
      <td style="text-align:center; width:50px;"><span style="background:#f1f5f9; padding:2px 6px; border-radius:4px; font-weight:700;">${s.qty}</span></td>
      <td style="text-align:right; font-weight:800; width:70px; color:#1e3a8a;">${s.weight} KGS</td>
    </tr>`).join('');

  openReportWindow('Stocklist', `
    <div class="header-flex">
      <img src="/logo.png" class="logo-img" />
      <div class="doc-title">Stocklist Report</div>
    </div>
    <table style="table-layout:fixed;">
      <thead><tr>
        <th style="width:30px;">NO</th>
        <th style="width:65px;">DATE</th>
        <th style="width:130px;">PO NUMBER</th>
        <th style="width:85px;">VESSEL</th>
        <th style="width:85px;">AWB/BL/LR</th>
        <th style="width:85px;">COMPANY</th>
        <th style="width:110px;">SUPPLIER</th>
        <th style="width:85px;">DIMENSIONS</th>
        <th style="text-align:center; width:50px;">QTY</th>
        <th style="text-align:right; width:70px;">WEIGHT</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>
  `);
}

export function generateOfflandPDF(items) {
  const rows = items.map((s, i) => `
    <tr>
      <td style="font-weight:700; color:#1e3a8a; width:40px;">${i + 1}</td>
      <td style="font-weight:800; white-space:nowrap;">${s.po}</td>
      <td>${s.vessel}</td>
      <td style="width: 160px; word-wrap: break-word;">${s.supplier || '—'}</td>
      <td style="text-align:center; width:80px;"><span style="background:#f1f5f9; padding:2px 6px; border-radius:4px; font-weight:700;">${s.qty}</span></td>
    </tr>`).join('');

  openReportWindow('Offland', `
    <div class="header-flex">
      <img src="/logo.png" class="logo-img" />
      <div class="doc-title">Offland Report</div>
    </div>
    <table>
      <thead><tr><th>NO</th><th>PO NUMBER</th><th>VESSEL</th><th>SUPPLIER</th><th style="text-align:center;">QTY</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
  `);
}

export function generateCompletionPDF(items) {
  const rows = items.map((s, i) => `
    <tr>
      <td style="font-weight:700; color:#1e3a8a; width:40px;">${i + 1}</td>
      <td style="font-weight:800; white-space:nowrap;">${s.po}</td>
      <td style="max-width: 200px; word-wrap: break-word;">${s.customer}</td>
      <td>${s.vessel}</td>
      <td style="text-align:right; font-weight:800; color:#1e3a8a;">${s.weight} KGS</td>
    </tr>`).join('');

  openReportWindow('Completion', `
    <div class="header-flex">
      <img src="/logo.png" class="logo-img" />
      <div class="doc-title">Completion Report</div>
    </div>
    <table>
      <thead><tr><th>NO</th><th>PO NUMBER</th><th>COMPANY</th><th>VESSEL</th><th style="text-align:right;">WEIGHT</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
  `);
}
